import * as React from "react";

export class Copyright extends React.Component<{}, {}> {
  public render() {
    return <div>© {new Date().getFullYear()} Microsoft</div>;
  }
}
